import React from 'react';
import { homePlatformWorks } from './data';

export const HomePlatformWorks: React.FC = () => {
  return (
    <section className="io-home-platform-works" aria-labelledby="io-home-platform-works-title">
      <div className="io-home-platform-works__bg" aria-hidden />
      <div className="io-home-platform-works__inner">
        <h2 id="io-home-platform-works-title" className="io-home-platform-works__heading">
          {homePlatformWorks.title}
        </h2>
        <p className="io-home-platform-works__subtitle">{homePlatformWorks.subtitle}</p>
        <div className="io-home-platform-works__phones">
          {homePlatformWorks.phones.map(phone => (
            <figure key={phone.id} className="io-home-platform-works__phone">
              <img
                src={phone.src}
                alt={phone.alt}
                className="io-home-platform-works__img"
                width={phone.width}
                height={phone.height}
                loading="lazy"
                decoding="async"
              />
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};
